// eslint-disable-next-line complexity
export function getFloorThreshold(value, thresholds, low, high) {
    if (low > high || value < thresholds[0].value) {
        return {};
    }

    const mid = Math.floor((low + high) / 2);

    if (value >= thresholds[high].value) {
        return thresholds[high];
    }

    if (thresholds[mid].value === value) {
        return thresholds[mid];
    }

    if (
        mid > 0 &&
        thresholds[mid - 1].value <= value &&
        value < thresholds[mid].value
    ) {
        return thresholds[mid - 1];
    }

    if (value < thresholds[mid].value) {
        return getFloorThreshold(value, thresholds, low, mid + 1);
    }

    return getFloorThreshold(value, thresholds, mid + 1, high);
}

export function getCellThreshold(value, thresholds) {
    return getFloorThreshold(value, thresholds, 0, thresholds.length - 1);
}

export function getStatusCellWidth(numberOfColumns) {
    return numberOfColumns ? `calc(99% / ${numberOfColumns})` : '100%';
}
